import AccessRequestHistoryBody from './AccessRequestHistoryBody';

export default AccessRequestHistoryBody;
